import React, { Component } from 'react';

import './blocking-render.css';

const textPadding = ( filler, value, width) => {
  let str = `${value}`;
  while( width > str.length) {
    str = `${filler.slice( 0, width-str.length)}${str}`;
  }
  return str;
}

class BlockingRender extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msUntilPublish: this.props.blockingConditions && this.props.blockingConditions.msUntilPublish,
    };

  }

  render() {
    // console.log( this.props);
    const width = this.props.customProps.width;
    const height = this.props.customProps.height;
    if( this.state.msUntilPublish) {
      if( this.state.msUntilPublish > 1000) {
        setTimeout( () => this.setState({ msUntilPublish: this.state.msUntilPublish - 1000}), 1000);
      } else {
        setTimeout( () => window.location.reload(), this.state.msUntilPublish);
      }
      const ms = Math.floor(this.state.msUntilPublish);
      const s = Math.floor(ms / 1000);
      const m = Math.floor(s / 60);
      const h = Math.floor(m / 60);
      const d = Math.floor(h / 24);
      const textWidth = 337;
      const textHeigth = 23;
      const left = (width - textWidth) / 2;
      const top = (height - textHeigth) / 2;
       // . {textPadding('0',ms%1000,4)}
      return (
        <div className='blocking-image' style={{backgroundImage: `url("${this.props.playlist[0].image}")`, width, height}}>
          <p style={{top, left}}>
            Time until start: {d} days - {textPadding('0',h%24,2)} : {textPadding('0',m%60,2)} : {textPadding('0',s%60,2)}
          </p>
        </div>
      );
    }
    const backgroundImage = `url("${this.props.playbackRestrictions.displayImageWhenBlock}")`;
    return (
      <div className='blocking-image' style={{backgroundImage, width, height}}>
        {/* <li> El contenido no esta disponible devido a tu localizacion o el dominio en que intentas visualizarlo. </li> */}
      </div>
    );
  }
}

export default BlockingRender;



// WEBPACK FOOTER //
// ./src/blocking-render/blocking-render.js